import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import useFiltersVariables from "components/Filters/useFiltersVariables";
import { EmptystateSearchNoResultsColored } from "components/icons/generated";
import SearchInput from "components/SearchInput";
import { getSearchQuery } from "components/SearchInput/helpers";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";

import IntegrationCard from "./components/Card";
import IntegrationsLayout from "./components/Layouts/IntegrationsLayout";
import IntegrationsListWrapper from "./components/ListWrapper";
import { FILTER_VARIABLES } from "./constants";
import { filterIntegrations } from "./helpers";
import { getIntegrationById, integrationIds } from "./registry";

const Integrations = () => {
  const [searchParams] = useSearchParams();
  const { filterVariables } = useFiltersVariables(FILTER_VARIABLES);

  const filteredIntegrations = useMemo(() => {
    const searchQuery = getSearchQuery(searchParams);

    const categoriesValues =
      filterVariables.predicates.find((predicate) => predicate.field === "Categories")?.constraint
        .enumEquals ?? [];
    const integrations = integrationIds.map(getIntegrationById);
    return filterIntegrations(integrations, searchQuery, categoriesValues);
  }, [filterVariables, searchParams]);

  return (
    <IntegrationsLayout
      searchBar={
        <SearchInput filtersOrderSettingsKey="integrations" placeholder="Search integrations..." />
      }
    >
      {filteredIntegrations.length === 0 ? (
        <Box align="center" justify="center" fullHeight fullWidth padding="x-large">
          <EmptyState
            title="No results"
            caption="Don't give up! Check the spelling or try something less specific."
            icon={EmptystateSearchNoResultsColored}
          />
        </Box>
      ) : (
        <IntegrationsListWrapper>
          {filteredIntegrations.map((integration) => (
            <IntegrationCard key={integration.id} {...integration} />
          ))}
        </IntegrationsListWrapper>
      )}
    </IntegrationsLayout>
  );
};

export default Integrations;
